import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import { matchPath } from "react-router";

import Header from "../components/header";
import Nav from "../components/nav";
import GalleryLink from "../components/gallerylink";
import Footer from "../components/footer";

import "./normalize.css";
import "./main.css";

const defaultMeta =
  "We manufacture custom made signs and awnings from the San Francisco Bay Area.";

const TemplateWrapper = ({ location, children }) => {
  const homeMatch = matchPath(location.pathname, { path: "/", exact: true });

  return (
    <React.Fragment>
      <Helmet titleTemplate="%s - Sign Awning" defaultTitle="Sign Awning">
        <meta name="description" content={defaultMeta} />
      </Helmet>
      <Header />
      <main>
        <Nav />
        <div id="right-side">
          <article id="content" className={homeMatch ? "home" : undefined}>
            {children()}
          </article>
          <div id="right-bottom">
            <GalleryLink className="feature-button">
              View Our Photo Gallery
            </GalleryLink>
          </div>
        </div>
      </main>
      <Footer />
    </React.Fragment>
  );
};

TemplateWrapper.propTypes = {
  children: PropTypes.func,
};

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js